var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "activity-container object-in-a-sentence"
  }, [_c('div', {
    staticClass: "select-image"
  }, [_c('div', {
    staticClass: "phrase"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentRound.text))])]), _c('ul', {
    staticClass: "images"
  }, _vm._l(_vm.currentRound.answers, function (answer) {
    return _c('li', {
      key: answer.id,
      staticClass: "image-container"
    }, [_c('button', {
      staticClass: "pure-button",
      on: {
        "click": function ($event) {
          return _vm.onSelectAnswer(answer);
        }
      }
    }, [_c('img', {
      class: _vm.getImageClasses(answer.id),
      attrs: {
        "alt": answer.answerImage.image.description,
        "src": answer.answerImage.image.src
      }
    })])]);
  }), 0)]), _c('article', {
    staticClass: "typing",
    attrs: {
      "aria-live": "assertive",
      "role": "region"
    }
  }, [_vm.selectedAnswer ? _c('div', {
    attrs: {
      "transition": _vm.transitionsDisabled ? '' : 'fade-05'
    }
  }, [_c('div', {
    staticClass: "round-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentRound.text) + " ")])]), _c('div', {
    staticClass: "color-block"
  }, [_c('color-block-text', {
    attrs: {
      "text": _vm.selectedAnswer.answer,
      "text-step": 0
    }
  })], 1), _c('span', {
    staticClass: "punctuation"
  }, [_vm._v(_vm._s(_vm.currentRound.punctuation))])]) : _vm._e()])])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }